module.exports = __webpack_public_path__ + "assets/Lato-Italic.26318a1467a5e5caf10b04cfa942d079632560cd7a29cec565fd1dc9f7ec5081.woff";